import React, {useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Collapse,
} from 'reactstrap';
import {  useForm} from "react-hook-form";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {connect, useSelector} from "react-redux";

// components
import SelectGeneric from '../../../components/select/selectGeneric';
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {
    FORM, INTERNATIONAL,
} from "../../../components/i18n/i18n";

// services & providers
import { faqService } from "../../../jwt/_services/hotel/faqService";
import { hotelCategoryProvider } from "../../../providers/hotelCategoryProvider";

// actions
import { syncGallery} from "../../../redux/actions/hotel/placeActions";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {FL_CATEGORY, FL_CODE,  FL_STATUS} from "../../../components/i18n/formLabels";
import {PH_CODE} from "../../../components/i18n/placeHolders";
import {setForm, setItem} from "../../../redux/actions/generics/IndexedActions";
import FaqLangs from "./_langs";

const FaqForm = ( props ) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject } = componentState?.data;

    const [status, setStatus] = useState( domainObject?.status || false);
    const [category, setCategory] = useState( domainObject?.category || null);

    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [showGeneral, setShowGeneral] = useState('regular'); // minimized | regular
    const [showFullGeneral, setShowFullGeneral] = useState(false); // minimized | regular

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                status: status,
                langs: langs,
            }
        };

        if (category)
            dataRequest.item.category = { id: category };

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, faqService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, faqService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, );
        props.onClose()
    }

    const notImplementedAction = () => {
        console.log('sin implementar');
    }

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    return (<>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Card className={'card-modal-medium'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        {
                            <>
                                <h2 className="card-modal-title">{app.name + ' / Preguntas frecuentes'}</h2>
                                <br />
                                <h5 className="card-modal-uid">{editMode ? 'uid: ' + domainObject?.uid : ''}</h5>
                            </>
                        }
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode &&
                                <>
                                    <Separator/>
                                    <GenericButton
                                        style={'table'}
                                        toolTip={showFullGeneral ? 'Ocultar formulario completo' : 'Ver formulario completo' }
                                        icon={showFullGeneral ? 'fa-eye-slash' : 'fa-eye'}
                                        permission={'search'}
                                        onClick={_ => setShowFullGeneral(!showFullGeneral)}
                                    />
                                    <GenericButton
                                        style={'table'}
                                        toolTip={TT_HISTORY}
                                        icon={'fa-clock'}
                                        permission={'search'}
                                        onClick={showHistory}
                                    />
                                    <TranslateButton item={domainObject} service={faqService} path={path}/>
                                    <GenericButton
                                        style={'danger-secondary'}
                                        toolTip={TT_DELETE}
                                        icon={'fa-trash'}
                                        permission={'delete'}
                                        onClick={notImplementedAction}
                                    />
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={returnToList}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label>{ FL_CODE }</Label>
                                    <Input
                                        type="text"
                                        name="code"
                                        placeholder={ PH_CODE }
                                        innerRef={register}
                                        className={(errors.code ? ' is-invalid' : '')}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>{ FL_CATEGORY }</Label>
                                    <br/>
                                    <SelectGeneric
                                        initialValue={ category }
                                        setExternalValue={ setCategory }
                                        provider={hotelCategoryProvider}
                                        getAllCategories={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>{'Orden'}</Label>
                                    <Input
                                        type="number"
                                        name="showOrder"
                                        min="0"
                                        placeholder="Ingrese el valor"
                                        innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>{ FL_STATUS }</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={ status }
                                        onChange={ _ => setStatus(!status) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Collapse isOpen={showFullGeneral} >
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>ID</Label>
                                        <Input type="id" name="id" id="id"
                                               disabled
                                               value={editMode ? domainObject?.id : ''}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <FormGroup>
                                            <Label>UID Firebase</Label>
                                            <Input type="id" name="uid" id="uid"
                                                   disabled
                                                   value={editMode ? domainObject?.uid : ''}
                                            />
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Collapse>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="far fa-edit mr-2"/>{INTERNATIONAL }
                        </CardTitle>
                        <CardBody>
                            <FaqLangs langs={langs} setLangs={setLangs} translatableLangs={translatableLangs} />
                        </CardBody>
                    </CardBody>
                </Card>
            </Form>
            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setItem,
    setForm,
    syncGallery
})

export default connect(mapStateToProps, mapActionsToProps)(FaqForm)
